import { get } from "../helpers/api_helper"

const VOUCHER_BASE_URL = "/vouchers"

export const claimVoucherByMerchantService = (payload, rejectWithValue) => get(`${VOUCHER_BASE_URL}/${payload.voucherCode}/${payload.merchantId}?totalProductsAmount=${payload.totalProductsAmount}`, {}, rejectWithValue)
